module.exports = __webpack_public_path__ + "img/expovina_03(1).5823eae9.jpg";